/**
 * Counter Block JS
 */

export const init = () => {
    const counterNumbers = document.querySelectorAll('.counter__number');

    if (!counterNumbers.length) return;

    const animateCounter = (el) => {
        const targetText = el.getAttribute('data-target');
        const match = targetText.match(/([^\d]*)(\d+)([^\d]*)/);
        
        if (!match) return;

        const prefix = match[1] || '';
        const targetValue = parseInt(match[2], 10);
        const suffix = match[3] || '';
        
        const duration = 1500; // 1.5 seconds
        let startTime = null;

        const step = (timestamp) => {
            if (!startTime) startTime = timestamp;
            const progress = Math.min((timestamp - startTime) / duration, 1);
            
            // Out Quint easing
            const easedProgress = 1 - Math.pow(1 - progress, 5);
            
            const currentValue = Math.floor(easedProgress * targetValue);
            el.innerText = `${prefix}${currentValue}${suffix}`;

            if (progress < 1) {
                window.requestAnimationFrame(step);
            }
        };

        window.requestAnimationFrame(step);
    };

    const observerOptions = {
        threshold: 0.2,
        rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                animateCounter(entry.target);
                observer.unobserve(entry.target);
            }
        });
    }, observerOptions);

    counterNumbers.forEach(number => {
        // Set initial state to 0 with prefix/suffix
        const targetText = number.getAttribute('data-target');
        const match = targetText.match(/([^\d]*)(\d+)([^\d]*)/);
        if (match) {
            number.innerText = `${match[1] || ''}0${match[3] || ''}`;
        }
        
        observer.observe(number);
    });
};
